<template>
  <Button
    size="md"
    variant="link"
    :disabled="disabled"
    :label="label || t('components.combobox.clear')"
    @click="emit('clear')"
  />
</template>

<script setup>
import { defineEmits } from "vue";
import { Button } from "@/SharedComponents/Buttons";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const emit = defineEmits(["clear"]);

defineProps({
  disabled: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
  },
});
</script>
